import Vue from 'vue';

export default Vue.component('dropdownlist', {
    template:`
    <div class="form-group form-group-sm">  
        <label class="font-size-sm" :for="inputId" v-if="settings.label">{{ settings.label }}</label>     
        <select ref="select" class="form-control" :style="selectStyle">
            <option v-if="settings.placeholder !== null" ></option>
            <option v-for="item in settings.items" :value="item.id" :selected="isSelected(item)">
                {{ item.text }}
            </option>
        </select>
    </div>
    `,
    props:{
        id: { 
            type: String, 
            default: null 
        },
        value: { 
            type: [String, Number], 
            default: null 
        },
        settings: {
            type: Object,
            default: null
        },
        width: {
            type: Number,
            default: null
        }
    },
    computed:{
        inputId() {
            return this.id !== null ? `select-${this.id}` : `select-${this._uid}`;
        },
        selectStyle(){
            return this.width !== null ? 'width: 100%' : '';
        }
    },
    methods:{
        isSelected(item){
            return item.id === this.value;
        }
    },
    mounted(){
        window.$(this.$refs.select)
            .select2({placeholder:  this.settings.placeholder, theme: 'bootstrap'})
            .on('select2:select select2:unselect', event => {
                this.$emit('update:value', $(event.target).val() || null);
            });
    },
    updated() {
        window.$(this.$refs.select).val(this.value).trigger('change.select2');
    },
});